module.exports = __webpack_public_path__ + "static/img/thinkhome.0b03be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thinkhome.png
// module id = pdka
// module chunks = 1